// @flow
import CryptoJS from 'crypto-js'

function encrypt (text: string, keyStr: string): string {
  let key = CryptoJS.enc.Utf8.parse(keyStr)
  let encryptedData = CryptoJS.AES.encrypt(text, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  })
  return encryptedData.toString()
}

// http://jser.io/2014/08/19/how-to-use-aes-in-crypto-js-to-encrypt-and-decrypt
export { encrypt }



// WEBPACK FOOTER //
// ./src/frame/core/encrypt.js